import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress ResizeObserver loop errors (Recharts dev-only noise)
const origError = window.addEventListener;
window.addEventListener('error', (e) => {
  if (e.message?.includes('ResizeObserver loop')) { e.stopImmediatePropagation(); }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
